import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { LocalStorageAdapter } from '@/lib/adapters/local-storage';
import { getInitialState } from '@/lib/utils/local-state';

export const adapter = new LocalStorageAdapter('cta');

export type SetCtaValueAction = PayloadAction<{
  key: keyof CtaState;
  value: any;
}>;

// Define a type for the slice state
type CtaState = typeof defaultInitialState;

// Define the initial state using that type
const defaultInitialState = {
  // Just in case business logic changes, it would allow to show the CTA again
  version: 1,
  // Controls whether the CTA should be shown or not
  shown: false,
  // Stores if the user has created a QR code
  createdCode: false,
  // Stores if the user has seen the stats page
  statsPage: false,
  // Controls how many times the user has visited the site duriing more than 2 minutes
  sessionCounter: 0,
};

export const ctaSlice = createSlice({
  name: 'cta',

  initialState: () => {
    let state = getInitialState(adapter, defaultInitialState);
    // Reset CTA trigger only if:
    // - the version has changed
    // - the user has already seen the CTA
    if (state.version !== defaultInitialState.version && state.shown) {
      state = { ...defaultInitialState };
    }

    return state;
  },

  reducers: {
    setCtaValue(state, action: SetCtaValueAction) {
      const { key, value } = action.payload;
      // @ts-ignore
      state[key] = value;
    },

    reset(state: CtaState) {
      return { ...defaultInitialState };
    },
  },
});

export const { setCtaValue } = ctaSlice.actions;

export default ctaSlice.reducer;
